import routingSaga from '~/sagas/routing/routing.saga';

export default routingSaga;
